import { HIDE_SIDEBAR, SHOW_SIDEBAR } from "redux/constants/sidebar";

const initialState = {
  isSidebarShow: true,
};

const sidebarReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case HIDE_SIDEBAR:
      return {
        isSidebarShow: action.payload,
      };
    case SHOW_SIDEBAR:
      return {
        isSidebarShow: action.payload,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
